(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const guideBlocksArr = document.querySelectorAll('.trusler-block--guidepost');

		guideBlocksArr.forEach(block => {

			const headingsArr = block.querySelectorAll('h2');
		  
			headingsArr.forEach( heading => {
				ParcelFunctions.inViewport(heading, 0.3, 0.15, 'heading-in-viewport');
			})

		});				

	});

})(jQuery);